import React from "react";
import UserService from "../services/UserService";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import qs from "qs";
import { Navigate } from "react-router-dom";

class ChangePasswordFromReset extends React.Component {
  app = this.props.app;

  state = {
    password: "",
    redirectToHome: false,
  };

  params = qs.parse(this.props.location.search.substring(1));

  resetPassword = async () => {
    console.log("resetPassword", this.params.userId, this.state.password);

    try {
      const message = await UserService.resetPassword(this.params.userId, this.params.accessToken, this.state.password);
      console.log("resetPassword response :", message);
      this.setState({ redirectToHome: true });
    } catch (err) {
      this.app.handleSnackbarOpen(err, this.app.snackbarClassNames.ERROR);
    }
  };

  render() {
    var buttonStyle = {
      margin: "20px",
    };

    if (this.state.redirectToHome === true) {
      return (
        <Navigate
          to={{
            pathname: "/",
          }}
        />
      );
    }

    return (
      <div>
        <div className="HomeHeader">
          <span className="HomeHeader-logo" />
          <h2>Tracy</h2>
        </div>
        <div className="HomeBody">
          <div className="ColumnCenter">
            <h1>Reset your password</h1>

            <p>Enter your new password below.</p>

            <TextField
              label="Password"
              type="password"
              autoComplete="current-password"
              placeholder="Password"
              onChange={(event) => this.setState({ password: event.target.value })}
            />
            <Button style={buttonStyle} color="primary" variant="contained" onClick={this.resetPassword}>
              Reset Password
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangePasswordFromReset;
